import { render } from "./SyncOrder.vue?vue&type=template&id=5ccb9ea4"
import script from "./SyncOrder.vue?vue&type=script&lang=js"
export * from "./SyncOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__